import { combineReducers } from "redux";
import loginReducer from "./login.reducer";
import brandReducer from "./brand.reducer";
import companyReducer from "./company.reducer";
import countryReducer from "./country.reducer";
import departmentReducer from "./department.reducer";
import yearReducer from "./year.reducer";
import userauthReducer from "./usernameauth.reducer";
import budgetsReducer from "./budgets.reducer";
import budgetmonthReducer from "./budgetmonth.reducer";
import updatebudgetmonthReducer from "./updatebudgetmonth.reducer";
import insertbudgetsReducer from "./insertbudgets.reducer";
import insertprojectReducer from "./insertproject.reducer";
import getprojectReducer from "./getproject.reducer";
import getprojectdetailReducer from "./getprojectdetail.reducer";
import getfilesReducer from "./getfiles.reducer";
import getbuheadReducer from "./getbuhead.reducer";
import updatebuheadReducer from "./updatebuhead.reducer";
import budgetsdetailReducer from "./budgetsdetail.reducer";
import reportfinalbybrandReducer from "./reportfinalbybrand.reducer";
import reportfinalbydeptsReducer from "./reportfinalbydepts.reducer";
import reportbudgetdetailReducer from "./reportbudgetdetail.reducer";
import sendemailbuheadReducer from "./sendemailbuhead.reducer";
import getforecastoneReducer from "./getforecastone.reducer";
import getforecasttwoReducer from "./getforecasttwo.reducer";
import getforecastthreeReducer from "./getforecastthree.reducer";
import getforecastfourReducer from "./getforecastfour.reducer";
import getforecastfiveReducer from "./getforecastfive.reducer";
import updateforecastReducer from "./updateforecast.reducer";
import updateinitialapproveReducer from "./updateinitialapprove.reducer";
import checktokenReducer from "./checktoken.reducer";
// Owner
import countryspecialReducer from "./countryspecial.reducer";
import companyspecialReducer from "./companyspecial.reducer";
import brandspecialReducer from "./brandspecial.reducer";
import departmentspecialReducer from "./departmentspecial.reducer";
import getspecialReducer from "./getspecial.reducer";
import insertspecialReducer from "./insertspecial.reducer";
import updatespecialReducer from "./updatespecial.reducer";
import deletespecialReducer from "./deletespecial.reducer";
import deleteprojectReducer from "./deleteproject.reducer";
import purchaseRequestReducer from "./purchaseRequest.reducer";
import deletespecialbyidReducer from "./deletespecialbyid.reducer";
import approvebudgetReducer from "./approvebudget.reducer";
import updateapprovebudgetReducer from "./updateapprovebudget.reducer";
import rejectapprovebudgetReducer from "./rejectapprovebudget.reducer";
import approvebudgethistoryReducer from "./approvebudgethistory.reducer";

// Budget FA
import getbudgetfaReducer from "./getbudgetfa.reducer";
import updatebudgetfaReducer from "./updatebudgetfa.reducer";
import loadbudgetfaReducer from "./loadbudgetfa.reducer";
import getmonthbudgetReducer from "./getmonthbudget.reducer";
import copymonthbudgetReducer from "./copymonthbudget.reducer";

import getbudgetcomparebybranddReducer from "./getbudgetcomparebybrandd.reducer";
import getbudgetcomparebybrandsReducer from "./getbudgetcomparebybrands.reducer";
import getbudgetcomparebydeptdReducer from "./getbudgetcomparebydeptd.reducer";
import getbudgetcomparebydeptsReducer from "./getbudgetcomparebydepts.reducer";

import productReducer from "./products.reducer";
import referenceReducer from "./reference.reducer";
import backOfficeReducer from "./backOffice.reducer";
import reportReducer from "./report.reducer";
import budgetAdjustmentReducer from "./budgetAdjustment.reducer";
import authorizationReducer from "./authorization.reducer";
import contractReducer from "./contract.reducer";

export default combineReducers({
  contractReducer,
  authorizationReducer,
  budgetAdjustmentReducer,
  loginReducer,
  referenceReducer,
  brandReducer,
  companyReducer,
  countryReducer,
  departmentReducer,
  yearReducer,
  userauthReducer,
  budgetsReducer,
  budgetmonthReducer,
  updatebudgetmonthReducer,
  insertbudgetsReducer,
  insertprojectReducer,
  getprojectReducer,
  getprojectdetailReducer,
  countryspecialReducer,
  companyspecialReducer,
  brandspecialReducer,
  departmentspecialReducer,
  getspecialReducer,
  insertspecialReducer,
  updatespecialReducer,
  deletespecialReducer,
  deleteprojectReducer,
  getfilesReducer,
  getbuheadReducer,
  purchaseRequestReducer,
  updatebuheadReducer,
  deletespecialbyidReducer,
  approvebudgetReducer,
  updateapprovebudgetReducer,
  rejectapprovebudgetReducer,
  approvebudgethistoryReducer,
  productReducer,
  budgetsdetailReducer,
  reportfinalbybrandReducer,
  reportfinalbydeptsReducer,
  reportbudgetdetailReducer,
  sendemailbuheadReducer,
  getforecastoneReducer,
  getforecasttwoReducer,
  getforecastthreeReducer,
  getforecastfourReducer,
  getforecastfiveReducer,
  updateforecastReducer,
  updateinitialapproveReducer,
  checktokenReducer,
  backOfficeReducer,
  reportReducer,
  getbudgetfaReducer,
  updatebudgetfaReducer,
  loadbudgetfaReducer,
  getbudgetcomparebybranddReducer,
  getbudgetcomparebybrandsReducer,
  getbudgetcomparebydeptdReducer,
  getbudgetcomparebydeptsReducer,
  getmonthbudgetReducer,
  copymonthbudgetReducer,
});
